<template>
  <div ref="animation"></div>
</template>

<script>

import bodymovin from 'lottie-web';
import * as AnimationData from 'site/js/settings/404-animation.json';

  export default {

    mounted: function() {
      this.initAnimation()
    },

    methods: {
      initAnimation: function ()
      {
        this.animation = bodymovin.loadAnimation({
          container: this.$refs.animation,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          animationData: AnimationData.default
        })
      }
    }
  }
</script>